import React, { useEffect, useRef } from 'react'
import PropTypes from 'prop-types'
import AlertStatus from '../../asset/alertStatus.svg'
import {
  CardWrapper,
  AlertStatusCard,
  AlertCardContainer,
  AlertCardHeader,
  AlertCardTitle,
  CardContentWrapper,
  AlertCardText,
} from './styles'
//import FooterText from '../PageFooter/FooterText'

const AlertCard = ({ title, cardContent }) => {
  const alertCard = useRef()
  useEffect(() => alertCard.current.focus())

  return (
    <CardWrapper
      role="alert dialog"
      tabIndex="0"
      aria-label={title}
      ref={alertCard}
    >
      <AlertStatusCard src={AlertStatus} alt="" />
      <AlertCardContainer>
        <AlertCardHeader>
          <AlertCardTitle tabIndex="-1">{title}</AlertCardTitle>
        </AlertCardHeader>
        <CardContentWrapper>
          {cardContent &&
            cardContent.map((item, index) => (
              <AlertCardText key={index}>{item}</AlertCardText>
            ))}
        </CardContentWrapper>
      </AlertCardContainer>
    </CardWrapper>
  )
}
AlertCard.proTotypes = {
  title: PropTypes.string,
  cardContent: PropTypes.array,
}

export default AlertCard
